import React from 'react';

interface GrainTextureProps {
  opacity?: number;
}

/**
 * GrainTexture component - adds a subtle grain texture overlay
 */
const GrainTexture: React.FC<GrainTextureProps> = ({ opacity = 0.4 }) => (
  <div 
    className="absolute inset-0 pointer-events-none mix-blend-overlay z-0"
    style={{
      opacity: opacity,
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`,
    }}
  />
);

export default GrainTexture;

